export const socialsData = {
    github: 'https://github.com/misathemeb',
    linkedIn: 'https://www.linkedin.com/in/melissa-bridi-ba8103122/',
    twitter: 'https://twitter.com/home'
   
}